/**
 * @generated SignedSource<<4db83dcf390be12a4118c6ccd5e389f2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpNewArrivalsCarousel_item$data = {
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly contemporaryTrackingString: string;
  readonly ecommerceTrackingParams: any | null;
  readonly firstPhotoWebPath: string | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductImageOnly_item" | "ItemHeartWrapper_item">;
  readonly " $fragmentType": "HpNewArrivalsCarousel_item";
};
export type HpNewArrivalsCarousel_item$key = {
  readonly " $data"?: HpNewArrivalsCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpNewArrivalsCarousel_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpNewArrivalsCarousel_item",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ecommerceTrackingParams",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contemporaryTrackingString",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductImageOnly_item"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "loadPortfolioData",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "8c7202ee0b843d9cd473ed1a0e439307";

export default node;
